export default __webpack_public_path__ + "static/media/1888.17889a17.png";